import { DomainMessagesTypes, type Message } from 'shared/domain/messages/message';

/**
 * During atomic save, protocol answers are merged locally and IndexedDB is
 * updated in the service worker. Skipping `updatedEntity` / `tableChanged`
 * avoids reading the open inspection and the inspection list (each read also
 * starts an inspections sync) again after every saved answer.
 */
export function isSkippedDuringAtomicSave(event: Message, atomicSaveEnabled: boolean): boolean {
  return (
    atomicSaveEnabled &&
    (event.type === DomainMessagesTypes.updatedEntity || event.type === DomainMessagesTypes.tableChanged)
  );
}
